export const PROMOTION_ALLOWED_PROVIDERS = ['booking', 'expedia', 'traveloka', 'ctrip', 'ctrip_mobile_web', 'ctrip_api'];

export const FE_ONLY_PROVIDERS = ['all', 'cheapest'];
